import filters from '../config/filters'

const colorsStatus = {
  created: {
    background: '#e9e9e7',
    color: '#616161'
  },
  approved: {
    background: '#A5AA72',
    color: '#ffffff'
  },
  paid: {
    background: '#F1FF57',
    color: '#616161'
  },
  packed: {
    background: '#56AEFF',
    color: '#ffffff'
  },
  sent: {
    background: '#7199BF',
    color: '#ffffff'
  },
  expired: {
    background: '#FF756E',
    color: '#ffffff'
  },
  declined: {
    background: '#AA7572',
    color: '#ffffff'
  }
}

export default {
  data () {
    return {
      colorsStatus
    }
  },
  methods: { ...filters }
}



// WEBPACK FOOTER //
// ./src/mixins/filters.js